import { DocumentFileFormat } from "./document-file-format.model";
import { DocumentFileLanguage } from "./document-file-language";

export class DocumentFile {
    DocumentFileId: number;
    LanguageId?: number;
    FileName: string;
    URL: string;
    DocumentFileFormatId?: number;
    FileThumb?: string;
    FileThumbString?: string;
    FileSize?: number;
    InsertBy: number;
    InsertDate: string;
    DocumentVersionId: number;

  DocumentFileFormat: DocumentFileFormat;
  DocumentFileLanguage: DocumentFileLanguage;
  DocumentFileLanguages: DocumentFileLanguage[];

    constructor() {
      this.DocumentFileFormat = new DocumentFileFormat();
      this.DocumentFileLanguage = new DocumentFileLanguage();
      this.DocumentFileLanguages = [];
    }
}
